export default __webpack_public_path__ + "static/media/sun.8994825e.svg";